// The ONLY place chargeback display labels are computed. The backend stores and
// returns the two orthogonal raw fields (defenseStatus + defenseResult); this
// module collapses them, client-side, into a single human-friendly label plus a
// stable internal key used for filtering/sorting and badge colors.
export const STATUS_LABELS = {
    'autodefended': 'Auto Defended',
    'indefensible': 'Indefensible',
    'accept-chargeback': 'Chargeback Accepted',
    'defense-won': 'Chargeback Won',
    'defense-lost': 'Chargeback Lost',
    'defense-submitted': 'Chargeback Submitted',
    'defense-needs-info': 'Needs Info',
    'defense-needs-review': 'Needs Review',
    'defense-needs-manual': 'Needs Manual Review',
    'defense-processing': 'Defense Processing'
};
// Display order for filter dropdowns + legends — action-needed first.
export const STATUS_KEYS = [
    'defense-needs-manual',
    'defense-needs-review',
    'defense-needs-info',
    'defense-submitted',
    'defense-processing',
    'defense-won',
    'defense-lost',
    'autodefended',
    'accept-chargeback',
    'indefensible'
];
// DaisyUI badge class per status. Action-needed statuses are warning/error;
// terminal good outcomes are success; in-flight is neutral/info.
export const STATUS_BADGE_CLASS = {
    'autodefended': 'badge-success',
    'indefensible': 'badge-ghost',
    'accept-chargeback': 'badge-ghost',
    'defense-won': 'badge-success',
    'defense-lost': 'badge-error',
    'defense-submitted': 'badge-info',
    'defense-needs-info': 'badge-warning',
    'defense-needs-review': 'badge-warning',
    'defense-needs-manual': 'badge-error',
    'defense-processing': 'badge-neutral'
};
// defenseResult (terminal business outcome) takes precedence over the
// operational defenseStatus. Unrecognized / legacy-only states fall back to
// "Defense Processing".
export const toStatusKey = (defenseStatus, defenseResult) => {
    switch (defenseResult) {
        case 'AUTO_DEFENDED':
            return 'autodefended';
        case 'INDEFENSIBLE':
            return 'indefensible';
        case 'ACCEPT_CHARGEBACK':
            return 'accept-chargeback';
        case 'CHARGEBACK_WON':
            return 'defense-won';
        case 'CHARGEBACK_LOST':
            return 'defense-lost';
        case 'AWAITING_CHARGEBACK_DECISION':
            return 'defense-submitted';
    }
    switch (defenseStatus) {
        case 'SUBMITTED_DEFENSE_DOC':
            return 'defense-submitted';
        case 'AWAITING_APALEO_DETAILS_RESOLUTION':
            return 'defense-needs-info';
        case 'REVIEWING_DEFENSE_DOC':
            return 'defense-needs-review';
        case 'AWAITING_MANUAL_INTERVENTION':
            return 'defense-needs-manual';
        default:
            return 'defense-processing';
    }
};
export const toStatusLabel = (defenseStatus, defenseResult) => STATUS_LABELS[toStatusKey(defenseStatus, defenseResult)];
// Deep-link to the unified case details page. Every row drills in, regardless
// of whether there is an open HITL gate — the page renders read-only when no
// gate is pending. The `hasPendingReview` distinction is now a row-level
// visual cue, not a link target.
export const caseLink = (pspReference) => `/cases/${pspReference}`;
